import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { contactInfoSignupStepUrl } from '@well/navigation';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { PaymentMethodService } from './payment-method.service';
import {
  PaymentMethodDto,
  PaymentMethodMetaModel,
  PaymentMethodRedirectService
} from '@well/company-libs/payment-method/shell-api';
import { switchMap, tap } from 'rxjs/operators';
import { JsonApiResource } from '@irian-ro/abstract-resource';

@Component({
  selector: 'signup-payment-method-step',
  templateUrl: './payment-method-step.component.html',
  styleUrls: ['./payment-method-step.component.scss'],
})
export class PaymentMethodStepComponent implements OnInit{
  router = inject(Router);
  route = inject(ActivatedRoute);
  http = inject(HttpClient);
  env = inject(EnvironmentService);
  paymentMethodService = inject(PaymentMethodService);
  paymentMethodRedirectService = inject(PaymentMethodRedirectService);
  iconClass = 'ui-icon-payment';

  paymentMethodTemplate: JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel> | null = null;
  subscriptionTypeUuid: string | null =null;

  legalEntityUuid!: string;

  onSave(event: PaymentMethodDto) {
    this.paymentMethodService.savePaymentMethodAtSignup(event).subscribe({
      next: (res) => {
        if(!res.meta.cardPaymentInitiationRequest) {
          this.router.navigate(contactInfoSignupStepUrl(this.legalEntityUuid));
        }
        else{
          this.paymentMethodRedirectService.navigateToPaymentWebsite(res.meta.cardPaymentInitiationRequest);
        }
      }
    })
  }

  ngOnInit(): void {
    this.route.params.pipe(
      tap((params) => {
        this.legalEntityUuid = params['legalEntityUuid'];
        this.subscriptionTypeUuid = params['subscriptionTypeUuid'];
      }),
      switchMap(() => {
        return this.paymentMethodService.getPaymentMethodTemplateAtSignup(this.subscriptionTypeUuid!)
      })
    ).subscribe((res: JsonApiResource<PaymentMethodDto, PaymentMethodMetaModel>) => {
      this.paymentMethodTemplate = res;
    })
  }

}
